import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import React from "react";

export default function HotelDetailSkeleton() {
    return (
        <div className="hw-page--width">
            <div className="py-6 space-y-6 mt-10">
                <div className="space-y-2 mt-10">
                    <Skeleton baseColor="white" height={40} width={"60%"} />
                    <Skeleton baseColor="white" height={20} width={"40%"} />
                </div>
                <div className="skeleton-gallery mt-16">
                    <div className="skeleton-gallery-left">
                        <Skeleton baseColor="white" height={500} />
                    </div>

                    <div className="skeleton-gallery-right">
                        <Skeleton baseColor="white" height={350} />
                        <Skeleton baseColor="white" height={150} />
                    </div>
                </div>
                <div className="skeleton-tabs mt-16">
                    {[80, 90, 100, 100].map((w, i) => (
                        <Skeleton baseColor="white" key={i} height={35} width={w} borderRadius={30} />
                    ))}
                </div>
                <div className="skeleton-section mt-16">
                    <Skeleton baseColor="white" height={35} width={200} />
                    <Skeleton baseColor="white" height={100} width={"100%"} borderRadius={10} />
                </div>
                <div className="skeleton-section mt-16">
                    <Skeleton baseColor="white" height={35} width={200} />
                    <Skeleton baseColor="white" height={500} width={"100%"} borderRadius={10} />
                </div>
                <div className="skeleton-rooms mt-16">
                    <Skeleton baseColor="white" height={30} width={200} />

                    <div className="skeleton-room-group mt-16">
                        <div className="skeleton-room-left">
                            <Skeleton baseColor="white" height={20} width={300} />
                            <div>
                                {[0, 1, 2, 3, 4].map((sec) => (
                                    <Skeleton baseColor="white" key={sec} height={15} width={150} />
                                ))}
                            </div>
                            <Skeleton baseColor="white" height={20} width={300} />
                        </div>

                        <Skeleton baseColor="white" height={210} width={400} className="room-img" />
                        <Skeleton baseColor="white" height={210} width={400} className="room-img" />
                    </div>
                </div>

                <div className="skeleton-section mt-16">
                    <Skeleton baseColor="white" height={35} width={200} />
                    <Skeleton baseColor="white" height={500} width={"100%"} borderRadius={10} />
                </div>

                <div className="skeleton-section mt-16">
                    <Skeleton baseColor="white" height={35} width={200} />
                    <Skeleton baseColor="white" height={300} width={"100%"} borderRadius={10} />
                </div>

            </div>
        </div>
    );
}
